export default __webpack_public_path__ + "static/media/NotFound.82bfbb7b.svg";